export default __webpack_public_path__ + "static/media/02f_fold-12.60629bc7.mp4";